export default "__VITE_ASSET__DRtG3CJV__"